import { GET_ERRORS } from '../types';

const getErrors = errors => ({ type: GET_ERRORS, payload: errors });
export default getErrors;
